import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import LogoWhite from '../../images/logoW.svg';
import { useTranslation } from '../../utils/hooks/translateHook';

function Footer() {
  const navigate = useNavigate();
  const t = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-col left">
          <p>{t("footerFirstLine")}</p>
          <p>{t("footerSecondLine")}</p>
        </div>
        <div className="footer-col right">
          <p> {t("disclaimerLine")}</p>
          <p>{t("footerCompanyLine")}</p>
        </div>
      </div>

      <div className="footer-bottom">
        <img
          src={LogoWhite}
          className="footer-logo"
          alt="VixAcademy Logo"
          onClick={() => navigate("/")}
        />
        <div className="footer-links">
          <span onClick={() => navigate("/terms")}>
            {t("termsAndConditions")}
          </span>
          <span className="divider">|</span>
          <span onClick={() => navigate("/privacy")}>
            {t("privacyAndCookies")}
          </span>
          <span className="divider">|</span>
          <span onClick={() => navigate("/contactus")}>
            {t("contactUs")}
          </span>
        </div>
      </div>
      <div className="footer-copy">
          ©2025 VIX Academy. All rights reserved. {/* Designed by <a href="https://rnmglobal-mkt.com" target='_blank'>RNM GLOBAL</a> */}
      </div>

    </footer>
  );
}

export default Footer;